import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouterStore = defineStore('routerstore', () => {

  const ultimaRotaVisitada = ref(null);
  const rotaOrigem = ref(null);
  const rotaAtual = ref(null);
  // A barra lateral inicia fechada; `initSidebar` também redefine este valor a
  // cada entrada no sistema
  const menuAtivo = ref(false);
  const rota_prelogin = ref('');

  const definirRotaAtual = (rota) => {
    rotaAtual.value = rota;
  };

  const definirMenuAtivo = (valor) => {
    menuAtivo.value = valor;
  }

  const definirUltimaRotaVisitada = (rota) => {
    ultimaRotaVisitada.value = rota;
  };

  const definirRotaOrigem = (rota) => {
    rotaOrigem.value = rota;
  };
  const definirRotaPreLogin = (rota) => {
    rota_prelogin.value = rota;
  }

  const limparRotaPreLogin = () => {
    rota_prelogin.value = null;
  }

  return {
    ultimaRotaVisitada,
    definirUltimaRotaVisitada,
    rotaOrigem,
    definirRotaOrigem,
    rotaAtual,
    definirRotaAtual,
    menuAtivo,
    rota_prelogin,
    definirMenuAtivo,
    definirRotaPreLogin,
    limparRotaPreLogin,
  }

}, { persist: true });
